var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEntityChanges(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5350_40119)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 2,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F5EDE2",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3398 24.2L31.3298 25.21L29.2598 23.18L30.2698 22.16C30.4698 21.95 30.8098 21.94 31.0498 22.16L32.3398 23.41C32.5498 23.62 32.5598 23.96 32.3398 24.2ZM24.4998 27.91L28.6698 23.72L30.7398 25.8L26.5798 30H24.4998V27.91ZM29.4998 16V18C33.8898 18.54 36.9998 22.53 36.4598 26.92C36.2391 28.689 35.4348 30.3339 34.1742 31.5944C32.9137 32.855 31.2688 33.6593 29.4998 33.88V35.88C34.9998 35.28 38.9498 30.34 38.3498 24.85C37.8298 20.19 34.1598 16.5 29.4998 16ZM27.4998 16C25.5398 16.18 23.6898 16.95 22.1698 18.2L23.5998 19.74C24.7198 18.84 26.0698 18.26 27.4998 18.06V16.06M20.7598 19.67C19.5055 21.185 18.7355 23.042 18.5498 25H20.5498C20.7398 23.58 21.2998 22.23 22.1898 21.1L20.7598 19.67ZM18.5598 27C18.7598 28.96 19.5298 30.81 20.7698 32.33L22.1898 30.9C21.3067 29.7696 20.7438 28.4226 20.5598 27H18.5598ZM23.5598 32.37L22.1698 33.74C23.6846 35.0027 25.5391 35.789 27.4998 36V34C26.0772 33.816 24.7302 33.2531 23.5998 32.37H23.5598Z",
    fill: "#837260"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5350_40119",
    x: 0.5,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5350_40119"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5350_40119",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntityChanges);
export default __webpack_public_path__ + "static/media/entity-changes.5809c2684b70b1749f1ed6adefb99a9d.svg";
export { ForwardRef as ReactComponent };